import axios from 'axios';

const API_BASE = 'https://viacep.com.br/ws/';

export const getAddress = (cep) => axios.get(`${API_BASE}${cep}/json`);
